import React from 'react';
import type { JSX } from 'react';

import classNames from 'classnames';

import styles from './Input.module.css';

interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'className'> {
  isInvalid?: boolean;
  className?: string;
}

export default function Input({
  type = 'text',
  isInvalid,
  className,
  ...rest
}: InputProps): JSX.Element {
  return (
    <input
      type={type}
      {...rest}
      className={classNames(styles.Input, className, { [styles.isInvalid]: isInvalid })}
    />
  );
}
